import { Component, OnInit } from '@angular/core';
import { ProspectOpenhouse } from 'app/models/prospect-openhouse';
import { Router, ActivatedRoute } from '@angular/router';
import { ProspectService } from 'services/prospect.service';
import { SplashService } from 'services/splash.service';
import { TrackingParameters } from 'app/models/tracking-parameter';

@Component({
  selector: 'app-openhouse-select',
  templateUrl: './openhouse-select.component.html',
  styleUrls: ['./openhouse-select.component.css']
})
export class OpenhouseSelectComponent implements OnInit {

  openHouses: ProspectOpenhouse[] = null;
  selectedOpenHouse: ProspectOpenhouse = null;
  address: string = null;
  yardiKey: string = null;
  errorMessage: string = null;

  constructor(private prospectService: ProspectService, public router: Router, public route: ActivatedRoute, private splashService: SplashService) {

    let address = localStorage.getItem('PropertyAddress');
    let yardiKey = localStorage.getItem('YardiID');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.yardiKey = yardiKey;
    }

    this.prospectService.getOpenHouseOptions(this.yardiKey).subscribe(res => this.onGetOpenHouseOptions(res), res => this.errorMessage = "Error pulling open house options.")

   }

  ngOnInit() {
    this.splashService.updateSplash("openhouse");
  }

  onGetOpenHouseOptions(openHouses: ProspectOpenhouse[])
  {
    this.openHouses = openHouses;

    if (this.openHouses.length === 0)
    {
      this.errorMessage = "There are no open houses scheduled for this property."
    }
  }

  selectOpenHouse(index: number)
  {

    this.openHouses.forEach(house => {
      house.Selected = false;
    });

    this.selectedOpenHouse = this.openHouses[index];
    this.openHouses[index].Selected = true;
  }

  onSubmit()
  {
    this.LoadFromLocalTourQueryParams();

    this.prospectService.selectOpenHouse(this.selectedOpenHouse).subscribe(res => this.submitResponse(res), res => this.errorMessage = "Error selecting open house.")
  }

  LoadFromLocalTourQueryParams()
  {
    let paramsString = localStorage.getItem('TrackingParameters');

    if (paramsString)
    {
      let params: TrackingParameters = JSON.parse(paramsString);
      this.selectedOpenHouse.ProspectSource = params.Source;
      this.selectedOpenHouse.Campaign = params.Campaign;
      this.selectedOpenHouse.AdGroup = params.AdGroup;
      this.selectedOpenHouse.Keyword = params.Keyword;
      this.selectedOpenHouse.AdCopy = params.AdCopy;
      this.selectedOpenHouse.Device = params.Device;
      this.selectedOpenHouse.Medium = params.Medium;
    }
  }

  submitResponse(openHouseKey: number)
  {
    this.router.navigate(['/tour/toursummary', openHouseKey]);
  }

}
